import { httpClient } from "lib/axios";

export const report_api = {
  get_cutoff: async date => {
    return await httpClient
      .get(`/cut_off/?date=${date}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  acknowledge_cutoff: async payload => {
    return await httpClient
      .post(`/cut_off/`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_delivery_report: async (date) => {
    return await httpClient
      .get(`/delivery_report/`,{params: {
        date: date,
      }},)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },

get_notify_report: async (params) => {
  const url = params ? `/notify_report/?${params}` : `/notify_report/`;
  return await httpClient
    .get(url)
    .then(res => res.data)
    .catch(err => {
      return { success: false, message: err.message || "Error fetching", data: [], count: 0 };
    });
},

  get_delivery_status: async mobile_no => {
    return await httpClient
      .get(`/notify-delivery-status/?mobile_no=${mobile_no}`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },

 get_order_status: async (payload) => {
  return await httpClient
    .post(`/order_status_report/`, payload)
    .then(res => res.data)
    .catch(err => ({
      success: false,
      message: err.message,
      data: [],
      count: 0
    }));
},

get_maintenance_report: async (startDate, endDate) => {
  return await httpClient
    .get(`website_maintenance/?start_date=${startDate}&end_date=${endDate}`)
    .then(res => res.data);
},

  get_itemwise_summary_report: async (params) => {
  return await httpClient
    .get(`/itemwise_summary_report/?${params}`)
    .then(res => res.data)
    .catch(err => {
      return { 
        success: false, 
        message: err.message || "Error fetching item-wise summary report", 
        data: [], 
        summary: {},
        total_count: 0,
        page: 1,
        page_size: 10,
        total_pages: 0
      };
    });
},

get_sales_report: async (start, end, view = null) => {
  const url = view
    ? `/sales-report/?start_date=${start}&end_date=${end}&view=${view}`
    : `/sales-report/?start_date=${start}&end_date=${end}`;

  return await httpClient
    .get(url)
    .then(res => res.data)
    .catch(err => ({ success: false, data: [] }));
},

get_hold_stock_report: async (params) => {
  return await httpClient
    .get(`/hold_stock_report/`, { params })
    .then(res => res.data)
    .catch(err => err);
},
get_stock_transfer_report: async (params) => {
  return await httpClient
    .get(`/stock_transfer_report/?${params}`)
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      throw err;   // 🔥 IMPORTANT
    });
}


};

